var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useCallback, useState, } from "react";
export var usePan = function (cb, deps) {
    var _a = useState([0, 0]), lastPosition = _a[0], savePosition = _a[1];
    var _b = useState(false), isPanning = _b[0], setPanState = _b[1];
    var onMouseDown = useCallback(function (ev) {
        if (ev.button !== 0) {
            return;
        }
        savePosition([ev.screenX, ev.screenY]);
        setPanState(true);
    }, [setPanState, savePosition]);
    var onTouchStart = useCallback(function (ev) {
        var touch = ev.touches[0];
        savePosition([touch.screenX, touch.screenY]);
        setPanState(true);
    }, [setPanState, savePosition]);
    var move = useCallback(function (p) {
        if (!isPanning) {
            return;
        }
        savePosition(function (prev) {
            cb([p[0] - prev[0], p[1] - prev[1]]);
            return p;
        });
    }, __spreadArray([savePosition, isPanning], deps, true));
    var onMouseMove = useCallback(function (ev) {
        var screenX = ev.screenX, screenY = ev.screenY;
        move([screenX, screenY]);
    }, [move]);
    var onTouchMove = useCallback(function (ev) {
        var _a = ev.touches[0], screenX = _a.screenX, screenY = _a.screenY;
        move([screenX, screenY]);
    }, __spreadArray([savePosition, isPanning], deps, true));
    var clear = useCallback(function () {
        savePosition([0, 0]);
        setPanState(false);
    }, [setPanState, savePosition]);
    return {
        onMouseDown: onMouseDown,
        onMouseMove: onMouseMove,
        onMouseUp: clear,
        onMouseLeave: clear,
        onTouchStart: onTouchStart,
        onTouchMove: onTouchMove,
        onTouchCancel: clear,
        onTouchEnd: clear,
    };
};
